import React, { Component } from "react";
import FloatingActionButton from "material-ui/FloatingActionButton";
import Icon from "material-ui-next/Icon";
import Tooltip from "material-ui-next/Tooltip";
import style from "./style";
import { colors } from "assets";

class FabView extends Component {
  static defaultProps = {
    backgroundColor: colors.secondary.normal,
    onClick: () => {},
    options: []
  };

  state = {
    visible: false
  };

  handleMainOnClick() {
    const { onClick, options } = this.props;

    if (options.length === 0) {
      onClick();
      return;
    }

    this.setState(prevProps => ({ visible: !prevProps.visible }));
  }

  optionItem(option, index) {
    const { visible } = this.state;

    const bottom = 100 + 60 * index;
    const delay = 100 * index;
    const { backgroundColor, onClick, icon, iconComponent, tooltip } = option;
    const visibilityStyle = visible ? style.subFabVisible : style.subFabHidden;
    const bottomStyle = visible ? `${bottom}px` : "20px";

    const subStyle = {
      ...style.subFab,
      ...visibilityStyle,
      bottom: bottomStyle,
      transitionDelay: `${delay}ms`
    };

    let TooltipComponent, tooltipProps;

    if (tooltip) {
      TooltipComponent = Tooltip;
      tooltipProps = { title: tooltip, placement: "left" };
    } else {
      TooltipComponent = React.div;
      tooltipProps = {};
    }

    return (
      <TooltipComponent {...tooltipProps} key={index}>
        <FloatingActionButton
          backgroundColor={backgroundColor}
          mini
          iconStyle={{ fill: "#222" }}
          style={subStyle}
          onTouchTap={onClick}
        >
          {iconComponent || <Icon>{icon}</Icon>}
        </FloatingActionButton>
      </TooltipComponent>
    );
  }

  render() {
    const { backgroundColor, icon, options, viewModel, tooltip } = this.props;
    const { supportVisible } = viewModel;

    let TooltipComponent, tooltipProps;

    if (tooltip) {
      TooltipComponent = Tooltip;
      tooltipProps = { title: tooltip, placement: "left" };
    } else {
      TooltipComponent = ({ children }) => <div>{children}</div>;
      tooltipProps = {};
    }

    return (
      <div>
        <TooltipComponent {...tooltipProps}>
          <FloatingActionButton
            backgroundColor={backgroundColor}
            onTouchTap={() => this.handleMainOnClick()}
            style={supportVisible ? style.supportVisible : style.supportHidden}
          >
            <Icon>{icon}</Icon>
          </FloatingActionButton>
        </TooltipComponent>

        {options.map((option, index) => this.optionItem(option, index))}
      </div>
    );
  }
}

export default FabView;



// WEBPACK FOOTER //
// ./src/components/support/fab/view.jsx